(() => {
  const revealElements = () => {
    const elements = document.querySelectorAll('.reveal-on-scroll:not(.is-visible)');

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.18,
      }
    );

    elements.forEach((element) => observer.observe(element));
  };

  document.addEventListener('DOMContentLoaded', revealElements);
  document.addEventListener('shopify:section:load', revealElements);
})();
